import { connect } from "react-redux";
import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { encryptPassword } from "../../../../utils/functions";
import { getSpk } from "../../../../../Redux/reducer/env";
import * as instanceActions from "../../../../../Redux/api";
import PropTypes from "prop-types";
import StepControl from "../../register/steps/stepControl";

import Modal from "../../../../utils/customModal";
import { errorContainer, loadingHtml } from "../../../../utils/functions";

import LockIcon from "../../../../../../static/images/secret-word.svg";
import CloseIcon from "../../../../../../static/images/close-icon.svg";
import ErrorIcon from "../../../../../../static/images/error-icon.svg";

export class ResetStep2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        secretWord: "",
      },
      errors: {
        secretWord: "",
      },
      modal: {
        show: false,
        type: "loading",
        modalMessage: { title: "", message: "" },
      },
    };
  }

  handlerChange(event) {
    const { user, errors } = this.state;
    errors[event.target.name] = "";
    user[event.target.name] = event.target.value;

    this.setState({ user, errors });
  }

  closeModal = () => {
    const { modal } = this.state;
    modal.show = false;
    modal.type = "loading";
    modal.modalMessage = { title: "", message: "" };
    this.setState({ modal });
  };

  getModalContent = () => {
    const { type, modalMessage } = this.state.modal;

    switch (type) {
      case "loading":
        return loadingHtml();
      case "error":
        return errorContainer(
          modalMessage.title,
          modalMessage.message,
          { continueBtn: { action: this.closeModal, text: 'Aceptar' } }
        );
    }
  };

  closeButton(element) {
    return this.state.user[element] != "" ? (
      <div
        className="button-auto input-w-aux__action clear-user"
        onClick={(event) => this.clear(event, element)}
      >
        <img src={CloseIcon} alt={`limpiar`} />
      </div>
    ) : null;
  }

  clear(event, element) {
    event.preventDefault();
    const user = this.state.user;
    user[element] = "";

    this.setState({ user });
  }

  submitForm(e) {
    e.preventDefault()
    const { user, errors } = this.state;

    //Validamos campos vacios
    if (user.secretWord != "") {
      errors.secretWord = "";
      this.setState({ errors });

      const { modal } = this.state;
      const { instance: { instanceAction } } = this.props;
      modal.show = true;
      this.setState({ modal });
      return instanceAction(`/password-recovery/check-secret-word`, "post", {
        codUser: encryptPassword(this.props.user.codUser, this.props.spk),
        secretWord: encryptPassword(user.secretWord, this.props.spk),
      })
        .then(() => {
          this.props.submitStep(true);
        })
        .catch((err) => {
          if (
            err.response !== undefined &&
            Array.isArray(err.response.data.notifications)
          ) {
            const notification = err.response.data.notifications[0];
            modal.modalMessage = {
              title: notification.message,
              message: notification.description,
            };
          }
          modal.type = "error";
          this.setState({ modal });
        });
    } else {
      if (user.secretWord == "") {
        errors.secretWord = "Debe completar este campo";
      }
      this.setState({ errors });
    }
  }

  inputErrors(id, hasFocus = false) {
    document.getElementById(id).classList.add("input--error");
    if (hasFocus) {
      document.getElementById(id).focus();
    }
  }

  displayError(id) {
    const { errors } = this.state;

    return errors[id] != "" ? (
      <div id="select-2-error" className="error">
        <span className="error__icon">
          <img src={ErrorIcon} alt="Error" />
        </span>
        <div className="error__text">{errors[id]}</div>
      </div>
    ) : null;
  }

  render() {
    const { modal } = this.state;
    return (
      <div id="step-2">
        <div className="user-credentials">
          <h1>Palabra secreta</h1>
          <div className="login-form">
            <form action="post" className="login" onSubmit={(e) => this.submitForm(e)}>
              <div className="input-w-aux">
                <img
                  className="button input-w-aux__icon"
                  src={LockIcon}
                  alt={`Contraseña`}
                />
                <input
                  id="secretWord"
                  name="secretWord"
                  className="input input--text input-w-aux__input input--active"
                  type={"text"}
                  placeholder={`Ingresar palabra secreta`}
                  autoComplete="off"
                  value={this.state.user.secretWord}
                  onChange={(event) => this.handlerChange(event)}
                  data-tip
                  data-for="secret-word-tooltip"
                />
                {this.closeButton("secretWord")}
                {this.displayError("secretWord")}
              </div>
              <StepControl
                currentStep={2}
                submitStep={(e) => this.submitForm(e)}
              />
            </form>
          </div>
        </div>
        <Modal
          key={`provider-users`}
          show={modal.show}
          hideClose={modal.type == "loading"}
          handleClose={() => this.closeModal()}
        >
          {this.getModalContent()}
        </Modal>
      </div>
    );
  }
}

ResetStep2.propTypes = {
  submitStep: PropTypes.func.isRequired,
};

export const mapStateToProps = (state) => {
  return {
    spk: getSpk(state),
  };
};

export const mapDispatch = (dispatch) => {
  return {
    instance: bindActionCreators(instanceActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(ResetStep2);
